var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRobot = function SvgRobot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    x: 2,
    y: 2,
    fill: "#E2FFEA",
    rx: 18
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    x: 2,
    y: 2,
    stroke: "#F4FFF7",
    strokeWidth: 4,
    rx: 18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#51C394",
    fillRule: "evenodd",
    d: "M20 10a.714.714 0 0 0-.715.714v2.33h-3.013a4.13 4.13 0 0 0-4.13 4.13v.52a3 3 0 0 0-.378.118c-.347.133-.662.33-.927.577a2.7 2.7 0 0 0-.62.864 2.5 2.5 0 0 0 0 2.038c.144.323.354.617.62.864a2.9 2.9 0 0 0 1.305.695v1.896a2.754 2.754 0 0 0 2.753 2.754h10.207a2.754 2.754 0 0 0 2.754-2.753V22.85a3 3 0 0 0 .38-.118 2.9 2.9 0 0 0 .927-.577c.265-.248.476-.541.619-.864a2.5 2.5 0 0 0 0-2.038 2.7 2.7 0 0 0-.62-.864 2.9 2.9 0 0 0-1.306-.696v-.519a4.13 4.13 0 0 0-4.13-4.13h-3.012v-2.33A.714.714 0 0 0 20 10m3.726 4.076h-7.454a3.1 3.1 0 0 0-3.098 3.098v7.573c0 .95.77 1.72 1.721 1.72h10.207c.95 0 1.721-.77 1.721-1.72v-7.573a3.1 3.1 0 0 0-3.097-3.098m-6.355 9.448a.516.516 0 0 1 .659-.315c.85.3 1.436.436 1.969.439.524.002 1.038-.124 1.74-.427a.516.516 0 0 1 .409.949c-.777.334-1.438.514-2.154.51-.707-.003-1.424-.185-2.308-.497a.516.516 0 0 1-.315-.66m-1.229-3.143c.433 0 .825-.366.825-.87s-.392-.87-.825-.87-.824.366-.824.87.392.87.824.87m0 1.032c1.026 0 1.858-.851 1.858-1.902s-.832-1.902-1.858-1.902c-1.025 0-1.857.851-1.857 1.902s.832 1.902 1.857 1.902m-4.317.202a2 2 0 0 1-.284-.215 1.6 1.6 0 0 1-.38-.528 1.47 1.47 0 0 1 0-1.2c.086-.193.213-.373.38-.528q.129-.12.284-.215v2.686m16.634-2.471a2 2 0 0 0-.284-.215v2.686q.155-.095.284-.216c.166-.155.294-.335.38-.527a1.47 1.47 0 0 0 0-1.2 1.6 1.6 0 0 0-.38-.528m-3.636.367c0 .504-.392.87-.824.87s-.825-.366-.825-.87.393-.87.825-.87.824.366.824.87m1.033 0c0 1.05-.832 1.902-1.857 1.902-1.026 0-1.857-.851-1.857-1.902s.831-1.902 1.857-1.902 1.857.851 1.857 1.902",
    clipRule: "evenodd"
  })));
};
export default SvgRobot;